import { css } from 'emotion';

export const ordersContainer = css({
  display: 'flex',
  gap: '1rem',
  marginTop: '.4em',
});
